import React, { useMemo } from "react";
import { PrismBanner } from "@prism-ui/react";
import PrismDataGrid from "../../../shared/PrismDataGrid";
import "./CareerTable.css";
import { formatMonthYear } from "../../../../util/dateUtils";

const COLUMNS = [
  { id: "company", header: "Company", accessor: (row) => row.company ?? "" },
  { id: "position", header: "Position", accessor: (row) => row.position ?? "" },
  {
    id: "start_date",
    header: "Start Date",
    accessor: (row) => row.start_date ?? "",
    cell: (row) => formatMonthYear(row.start_date),
  },
  {
    id: "end_date",
    header: "End Date",
    accessor: (row) => row.end_date ?? "",
    cell: (row) =>
      row.end_date ? formatMonthYear(row.end_date) : <em>Present</em>,
  },
];

const CareerTable = (props) => {
  const rows = useMemo(
    () =>
      props.careerEntries
        // The row id is derived from the entry's position in the *unsorted* prop so it
        // stays stable when sorting reorders the list. Unsaved entries have no `id`.
        .map((career, index) => ({
          ...career,
          _rowId:
            career.id != null ? `career-${career.id}` : `career-idx-${index}`,
        }))
        .sort(
          (a, b) => new Date(b.start_date || 0) - new Date(a.start_date || 0)
        ),
    [props.careerEntries]
  );

  if (props.careerEntries.length === 0)
    return (
      <PrismBanner tone="secondary" layout="inline">
        You have not entered your career history
      </PrismBanner>
    );

  return (
    <div className="career-table">
      <PrismDataGrid
        keyField="_rowId"
        caption="Career history"
        data={rows}
        columns={COLUMNS}
      />
    </div>
  );
};

export default CareerTable;
